export default "__VITE_ASSET__DAV7y63j__"